<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
import { useHeadConfigComposable } from '~/modules/head/composables/useHeadConfigComposable'
import './zod-config'
useHeadConfigComposable()
</script>

<style>
@import '@/assets/css/sidebarBurger.css';
@import '@/assets/css/t-lazyimg.css';
@import '@/assets/css/t-alert.css';
@import '@/assets/css/t-recaptcha.css';
@import '@/assets/css/footerApps.css';
</style>
